import { alpha, Components, Theme } from '@mui/material';

const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      gap: theme.spacing(theme.spacingSizes.xs),

      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[900], 0.05),
      },

      '&.Mui-selected': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.borderColor.main}`,

        '&:hover': {
          backgroundColor: theme.palette.background.paper,
        },
      },
    }),
  },
};

export default MuiListItemButton;
